import apiSlice from '../api/slice'
import { TAGS } from '../../constants/tags'

const dispositionsSlice = apiSlice.injectEndpoints({
  name: 'dispositions',
  endpoints: (builder) => ({
    getAllDispositions: builder.query({
      query: () => ({ url: `/v1/admin/dispositions`, method: 'GET' }),
      transformResponse: (response) => response.data,
      providesTags: [TAGS.DISPOSITIONS],
    }),
    postDisposition: builder.mutation({
      query: (payload) => ({ url: `/v1/admin/dispositions`, method: 'POST', body: payload }),
      invalidatesTags: [TAGS.DISPOSITIONS],
    }),
    deleteDisposition: builder.mutation({
      query: (dispositionId) => ({ url: `/v1/admin/dispositions/${dispositionId}`, method: 'DELETE' }),
      invalidatesTags: [TAGS.DISPOSITIONS],
    }),
  }),
})

export const { useGetAllDispositionsQuery, usePostDispositionMutation, useDeleteDispositionMutation } =
  dispositionsSlice
